<template>
    <component
        :is="component"
        class="FooterLink relative block py-2 text-smaller leading-[17px] tracking-normal text-gray-800 dark:text-txt-body hover:underline"
        :class="{ 'float-left mr-5 last:mr-0 sm:float-none sm:m-0': inline, 'hover:cursor-not-allowed': disabled }"
        v-bind="componentAttrs"
    >
        <div
            v-if="disabled"
            v-show="showBubble"
            class="absolute -top-6 rounded bg-black dark:bg-subtle px-3 py-1.5 text-center text-white dark:text-txt-body"
        >
            Pripravujeme
        </div>
        <div @mouseenter="showBubble = true" @mouseleave="showBubble = false">
            <slot />
        </div>
    </component>
</template>

<script setup lang="ts">
import { computed, ref, useAttrs } from 'vue'

defineProps({
    inline: Boolean,
    disabled: Boolean
})

const attrs = useAttrs()
const showBubble = ref(false)

const isNuxtLink = computed(() => Boolean(attrs.to))
const isLink = computed(() => Boolean(attrs.href))
const componentAttrs = computed(() => {
    if (!isNuxtLink.value) {
        return attrs
    }

    return {
        noPrefetch: true,
        ...attrs
    }
})

const component = computed(() => {
    if (isNuxtLink.value) {
        return resolveComponent('NuxtLink')
    }

    if (isLink.value) {
        return 'a'
    }

    return 'div'
})
</script>
